import React from "react";

import { isImageUrl } from "utils/cms/icon";

import CmsPreviewShell from "./CmsPreviewShell";
import mockData from "./mockData.json";

import type { CmsComponentProps, ShortcutMock } from "./types";

const ShortcutComponent: React.FC<CmsComponentProps> = ({ layout, items: userItems }) => {
  const items =
    userItems && userItems.length > 0
      ? userItems
          .filter((i) => i.is_active !== false)
          .map((i, idx) => ({
            id: idx,
            title: i.title,
            icon: i.icon ?? "",
            link: i.link ?? "",
          }))
      : (mockData.shortcut as ShortcutMock[]);

  return (
    <CmsPreviewShell>
      <div className={`cms-shortcut cms-shortcut--${layout}`}>
        {items.map((item) => {
          const iconIsImage = isImageUrl(item.icon);
          const iconClass = iconIsImage ? "cms-shortcut__icon cms-shortcut__icon--image" : "cms-shortcut__icon";
          return (
            <div key={item.id} className="cms-shortcut__item">
              <span className={iconClass}>{iconIsImage ? <img src={item.icon} alt={item.title} /> : item.icon || "❓"}</span>
              <span className="cms-shortcut__label">{item.title}</span>
            </div>
          );
        })}
      </div>
    </CmsPreviewShell>
  );
};

export default ShortcutComponent;
